// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, select } from 'redux-saga/effects';
import { getAccountDrawerWaysToEarnCacheTTL } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import EARNEXTRAPOINTS_CONSTANTS from '../EarnExtraPointsTile.constants';
import { validateReduxCache } from '../../../../../../../utils/cache.util';
import { setEarnExtraPointsList, showLoader, hideLoader } from './EarnExtraPointsTile.actions';
import { getExtraPointsActivityList } from '../../../../../../../services/abstractors/account/userExtraPoints';

export function* getEarnExtraPointsListSaga(action = {}) {
  const { payload } = action;
  try {
    yield put(showLoader());
    const ExtraPointsActivityList = yield call(getExtraPointsActivityList);
    if (payload && payload.isAccountDrawer) {
      const cacheTTL = yield select(getAccountDrawerWaysToEarnCacheTTL);
      yield put(
        setEarnExtraPointsList({
          extraPointsActivityList: ExtraPointsActivityList,
          isAccountDrawer: payload.isAccountDrawer,
          cacheTTL,
        })
      );
    } else {
      yield put(setEarnExtraPointsList(ExtraPointsActivityList));
    }
  } catch (err) {
    yield null;
  } finally {
    yield put(hideLoader());
  }
}

export function* EarnExtraPointsSaga() {
  const cachedEarnExtraPointsList = validateReduxCache(getEarnExtraPointsListSaga);
  yield takeLatest(EARNEXTRAPOINTS_CONSTANTS.GET_EARNEXTRAPOINTS_LIST, cachedEarnExtraPointsList);
}

export default EarnExtraPointsSaga;
